module.exports = __webpack_public_path__ + "img/map_icon1.70bec5c6.png";